import "./Tag.scss";

export default {
  root: "im-tag",
  rqth: "im-tag--rqth",
  superEnterprise: "im-tag--super-enterprise",
  lbb: "im-tag--lbb",
  voluntaryToImmersion: "im-tag--voluntaryToImmersion",
  prescripteur: "im-tag--prescripteur",
  structureAccompagnement: "im-tag--structureAccompagnement",
  etablissement: "im-tag--etablissement",
};
